import React, { Component } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import { AuthProvider } from './context/AuthContext';
import Layout from './components/layout/Layout';
import Dashboard from './pages/Dashboard';
import MerchantList from './pages/merchants/MerchantList';
import MerchantForm from './pages/merchants/MerchantForm';
import MerchantDetails from './pages/merchants/MerchantDetails';
import UserList from './pages/users/UserList';
import UserForm from './pages/users/UserForm';
import RoleManagement from './pages/users/RoleManagement';
import Login from './pages/auth/Login';
import ForgotPassword from './pages/auth/ForgotPassword';
import QRGenerator from './pages/qrc/QRGenerator';
import ProtectedRoute from './components/auth/ProtectedRoute';
// Previously commented components - now imported
import AuditLogs from './pages/users/AuditLogs';
import SessionHistory from './pages/users/SessionHistory';
import AggregatorManagement from './pages/aggregators/AggregatorManagement';
import ChainMerchantSetup from './pages/aggregators/ChainMerchantSetup';
import IndividualMerchant from './pages/aggregators/IndividualMerchant';
import HierarchyView from './pages/aggregators/HierarchyView';
import TillList from './pages/tills/TillList';
import TillForm from './pages/tills/TillForm';
import BulkQR from './pages/bulk/BulkQR';
import BulkRTP from './pages/bulk/BulkRTP';
import BulkMerchant from './pages/bulk/BulkMerchant';
import DisputeList from './pages/disputes/DisputeList';
import DisputeForm from './pages/disputes/DisputeForm';
import DiscountManagement from './pages/discounts/DiscountManagement';
import TransactionDetailReport from './pages/reports/TransactionDetailReport';
import TransactionSummaryReport from './pages/reports/TransactionSummaryReport';
import MerchantPendingPayments from './pages/reports/MerchantPendingPayments';
import FailedPaymentReports from './pages/reports/FailedPaymentReports';
// Transaction Rules Management
import TransactionRulesDashboard from './pages/transaction-rules/TransactionRulesDashboard';
import RulesManagement from './pages/transaction-rules/RulesManagement';
import RiskRuleAlerts from './pages/transaction-rules/RiskRuleAlerts';
import TransactionMonitoring from './pages/transaction-rules/TransactionMonitoring';
import RulesAuditLogs from './pages/transaction-rules/RulesAuditLogs';
// Merchant Portal Components
import MerchantPortal from './pages/merchant-portal/MerchantPortal';
import MerchantDashboard from './pages/merchant-portal/MerchantDashboard';
import MerchantTransactions from './pages/merchant-portal/MerchantTransactions';
import MerchantQRGenerator from './pages/merchant-portal/MerchantQRGenerator';
import MerchantPaymentMonitor from './pages/merchant-portal/MerchantPaymentMonitor';
import MerchantAccessControl from './pages/admin/MerchantAccessControl';
export function App() {
  return <ThemeProvider data-id="element-0">
      <Router data-id="element-1">
        <AuthProvider data-id="element-2">
          <Routes data-id="element-3">
            <Route path="/login" element={<Login data-id="element-5" />} data-id="element-4" />
            <Route path="/forgot-password" element={<ForgotPassword data-id="element-7" />} data-id="element-6" />
            <Route element={<ProtectedRoute data-id="element-9" />} data-id="element-8">
              <Route element={<Layout data-id="element-11" />} data-id="element-10">
                <Route path="/" element={<Navigate to="/dashboard" replace data-id="element-13" />} data-id="element-12" />
                <Route path="/dashboard" element={<Dashboard data-id="element-15" />} data-id="element-14" />
                {/* User & Role Management */}
                <Route path="/users" element={<UserList data-id="element-17" />} data-id="element-16" />
                <Route path="/users/new" element={<UserForm data-id="element-19" />} data-id="element-18" />
                <Route path="/users/edit/:id" element={<UserForm data-id="element-21" />} data-id="element-20" />
                <Route path="/roles" element={<RoleManagement data-id="element-23" />} data-id="element-22" />
                <Route path="/audit-logs" element={<AuditLogs data-id="element-25" />} data-id="element-24" />
                <Route path="/session-history" element={<SessionHistory data-id="element-27" />} data-id="element-26" />
                {/* Merchant Onboarding */}
                <Route path="/merchants" element={<MerchantList data-id="element-29" />} data-id="element-28" />
                <Route path="/merchants/new" element={<MerchantForm data-id="element-31" />} data-id="element-30" />
                <Route path="/merchants/edit/:id" element={<MerchantForm data-id="element-33" />} data-id="element-32" />
                <Route path="/merchants/details/:id" element={<MerchantDetails data-id="element-35" />} data-id="element-34" />
                {/* QR Code Generator */}
                <Route path="/qrc-generator" element={<QRGenerator data-id="element-37" />} data-id="element-36" />
                {/* Aggregator & Super Merchant */}
                <Route path="/aggregators" element={<AggregatorManagement data-id="element-39" />} data-id="element-38" />
                <Route path="/chain-merchants" element={<ChainMerchantSetup data-id="element-41" />} data-id="element-40" />
                <Route path="/individual-merchant" element={<IndividualMerchant data-id="element-43" />} data-id="element-42" />
                <Route path="/hierarchy" element={<HierarchyView data-id="element-45" />} data-id="element-44" />
                {/* Till Management */}
                <Route path="/tills" element={<TillList data-id="element-47" />} data-id="element-46" />
                <Route path="/tills/new" element={<TillForm data-id="element-49" />} data-id="element-48" />
                <Route path="/tills/edit/:id" element={<TillForm data-id="element-51" />} data-id="element-50" />
                {/* Bulk Operations */}
                <Route path="/bulk-qr" element={<BulkQR data-id="element-53" />} data-id="element-52" />
                <Route path="/bulk-rtp" element={<BulkRTP data-id="element-55" />} data-id="element-54" />
                <Route path="/bulk-merchant" element={<BulkMerchant data-id="element-57" />} data-id="element-56" />
                {/* Discount Management */}
                <Route path="/discount-management" element={<DiscountManagement data-id="element-59" />} data-id="element-58" />
                {/* Dispute Management */}
                <Route path="/disputes" element={<DisputeList data-id="element-61" />} data-id="element-60" />
                <Route path="/disputes/new" element={<DisputeForm data-id="element-63" />} data-id="element-62" />
                <Route path="/disputes/edit/:id" element={<DisputeForm data-id="element-65" />} data-id="element-64" />
                {/* Transaction Rules Management */}
                <Route path="/transaction-rules/dashboard" element={<TransactionRulesDashboard data-id="element-67" />} data-id="element-66" />
                <Route path="/transaction-rules/rules" element={<RulesManagement data-id="element-69" />} data-id="element-68" />
                <Route path="/transaction-rules/alerts" element={<RiskRuleAlerts data-id="element-71" />} data-id="element-70" />
                <Route path="/transaction-rules/monitoring" element={<TransactionMonitoring data-id="element-73" />} data-id="element-72" />
                <Route path="/transaction-rules/audit-logs" element={<RulesAuditLogs data-id="element-75" />} data-id="element-74" />
                {/* Reports */}
                <Route path="/reports/transaction-detail" element={<TransactionDetailReport data-id="element-77" />} data-id="element-76" />
                <Route path="/reports/transaction-summary" element={<TransactionSummaryReport data-id="element-79" />} data-id="element-78" />
                <Route path="/reports/pending-payments" element={<MerchantPendingPayments data-id="element-81" />} data-id="element-80" />
                <Route path="/reports/failed-payments" element={<FailedPaymentReports data-id="element-83" />} data-id="element-82" />
                {/* Merchant Portal Access Control */}
                <Route path="/merchant-access" element={<MerchantAccessControl data-id="element-85" />} data-id="element-84" />
              </Route>
            </Route>
            {/* Merchant Portal Routes */}
            <Route element={<ProtectedRoute data-id="element-87" />} data-id="element-86">
              <Route element={<MerchantPortal data-id="element-89" />} data-id="element-88">
                <Route path="/merchant-portal" element={<Navigate to="/merchant-portal/dashboard" replace data-id="element-91" />} data-id="element-90" />
                <Route path="/merchant-portal/dashboard" element={<MerchantDashboard data-id="element-93" />} data-id="element-92" />
                <Route path="/merchant-portal/transactions" element={<MerchantTransactions data-id="element-95" />} data-id="element-94" />
                <Route path="/merchant-portal/qr-generator" element={<MerchantQRGenerator data-id="element-97" />} data-id="element-96" />
                <Route path="/merchant-portal/payment-monitor" element={<MerchantPaymentMonitor data-id="element-99" />} data-id="element-98" />
                {/* Other merchant portal routes will be added here */}
                <Route path="/merchant-portal/reports" element={<ComingSoon featureName="Reports" data-id="element-101" />} data-id="element-100" />
                <Route path="/merchant-portal/profile" element={<ComingSoon featureName="Profile Management" data-id="element-103" />} data-id="element-102" />
                <Route path="/merchant-portal/campaigns" element={<ComingSoon featureName="Campaigns" data-id="element-105" />} data-id="element-104" />
                <Route path="/merchant-portal/settings" element={<ComingSoon featureName="Settings" data-id="element-107" />} data-id="element-106" />
              </Route>
            </Route>
            <Route path="*" element={<Navigate to="/login" replace data-id="element-109" />} data-id="element-108" />
          </Routes>
        </AuthProvider>
      </Router>
    </ThemeProvider>;
}
// Temporary component for pages that are coming soon
const ComingSoon: React.FC<{
  featureName: string;
}> = ({
  featureName
}) => {
  return <div className="flex flex-col items-center justify-center min-h-[60vh] text-center p-4" data-id="element-110">
      <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-2" data-id="element-111">
        {featureName} Coming Soon
      </h2>
      <p className="text-gray-500 dark:text-gray-400 max-w-md mb-6" data-id="element-112">
        We're working hard to bring you this feature. It will be available soon!
      </p>
      <div className="w-16 h-1 bg-blue-500 rounded mb-6" data-id="element-113"></div>
      <a href="/merchant-portal/dashboard" className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors" data-id="element-114">
        Back to Dashboard
      </a>
    </div>;
};